import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface Fund {
    fundId: number
    name: string;
    description: string;
    shortDescription: string;
}

interface FundState {
    allMasterFunds: Fund[];
    isfundOrderProcessing: boolean
}

const initialState: FundState = {
    allMasterFunds: [],
    isfundOrderProcessing: false,
};

const fundSlice = createSlice({
    name: 'fund',
    initialState,
    reducers: {
        setAllMasterFunds: (state, { payload }: PayloadAction<Fund[] | null>) => {
            state.allMasterFunds = payload ?? [];
        },
        setIsFundOrderProcessing: (state, { payload }: PayloadAction<boolean>) => {
            state.isfundOrderProcessing = payload ?? false;
        },
    },
});

export const { setAllMasterFunds, setIsFundOrderProcessing } = fundSlice.actions;

export default fundSlice.reducer;
